import React from 'react';
import '../css/LegalPages.css';

const Contact = () => {
  return (
    <div className="legal-container">
      <h1>İletişim</h1>

      <section>
        <h3>1. İletişim Kanallarımız</h3>
        <p>
          Her türlü soru, görüş, öneri ve talepleriniz için bize aşağıdaki iletişim bilgilerinden ulaşabilirsiniz.
          Tüm başvurular titizlikle değerlendirilmekte olup, en geç <strong>24 saat içinde dönüş yapılmaktadır.</strong>
        </p>
      </section>

      <section>
        <h3>2. E-posta Adresimiz</h3>
        <p>
          Destek, teknik sorunlar, üyelik işlemleri ve işletme başvuruları için:<br />
          📧 <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a>
        </p>
      </section>

      <section>
        <h3>3. Destek Talepleri</h3>
        <p>
          Platform kullanımında yaşadığınız sorunları, rezervasyon hatalarını, ödeme sorunlarını
          veya işletme paneli ile ilgili teknik destek taleplerinizi bize iletebilirsiniz.
        </p>
        <p>
          Mesajlarınıza genellikle <strong>aynı gün içinde</strong> yanıt verilir.
        </p>
      </section>

      <section>
        <h3>4. İş Ortağı & İşletme Başvuruları</h3>
        <p>
          İşletmenizi Halısahacım platformuna eklemek, reklam iş birlikleri veya sponsorluk projeleri için 
          bizimle iletişime geçebilirsiniz.
        </p>
        <p>
          İşletme kayıt ve aktivasyon süreçleri ekibimiz tarafından birebir takip edilir.
        </p>
      </section>

      <section>
        <h3>5. Geri Bildirim ve Öneriler</h3>
        <p>
          Platformun gelişimine katkı sağlayacak tüm görüşlerinizi memnuniyetle karşılıyoruz.
          Kullanıcı deneyimini sürekli iyileştirmek için her öneriyi değerlendiriyoruz.
        </p>
      </section>

      <section>
        <h3>6. Çalışma Saatlerimiz</h3>
        <p>
          Destek ekibimiz haftanın 7 günü hizmet vermektedir.<br />
          📅 <strong>Hafta içi – Hafta sonu:</strong> 09:00 – 22:00
        </p>
      </section>

      <section>
        <h3>7. Yasal Bilgiler</h3>
        <p>
          Bu iletişim sayfası, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve ilgili yönetmeliklere uygun 
          olarak hazırlanmıştır. Kullanıcıların hakları, gizlilik süreçleri ve veri işleme detayları 
          “Gizlilik Politikası” ve “KVKK Aydınlatma Metni” içinde açıklanmaktadır.
        </p>
      </section>

      <section>
        <h3>8. Resmî Yazışmalar</h3>
        <p>
          Resmî başvurular, hukuki talepler ve bildirimler için e-posta üzerindeki iletişim kanalımız kullanılabilir.
        </p>
      </section>
    </div>
  );
};

export default Contact;
